<template>
  <div class="flex items-center gap-2">
    <BankNote class="w-8 h-8 text-green-500" />
    <div class="flex flex-col gap-1 py-0.5">
      <span class="text-sm font-semibold"> Оплата при получении</span>
      <span
        v-if="bookingPaymentPercent"
        class="text-xs"
      >
        Бронь по предоплате {{ bookingPaymentPercent }}%
      </span>
      <span
        v-else
        class="text-xs"
      > Бронирование бесплатно </span>
    </div>
  </div>
</template>

<script>
import BankNote from '~/assets/svg/ui/bank-note.svg?component'

export default {
  name: 'BookingInfo',
  components: {
    BankNote,
  },
  props: {
    bookingPaymentPercent: {
      type: Number,
      required: true,
    },
  },
}
</script>
